import { render } from "./LbrxTicketVertical.vue?vue&type=template&id=0b32ac92&scoped=true"
import script from "./LbrxTicketVertical.vue?vue&type=script&lang=js"
export * from "./LbrxTicketVertical.vue?vue&type=script&lang=js"

import "./LbrxTicketVertical.vue?vue&type=style&index=0&id=0b32ac92&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b32ac92"]])

export default __exports__